import styled from 'styled-components';

export const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${({ theme }) => theme.palette.commons.background.infotip};
`;

export const ProgressBarFill = styled.div<{ progress: number }>`
  scale: ${({ progress }) => progress / 100} 1;
  transform-origin: left;
  height: 100%;
  background-image: ${({ theme }) => theme.palette.brand.linear_gradient ?? theme.palette.brand.color};
  transition: scale 0.5s cubic-bezier(1, 0, 0, 1);
`;
